


























import { defineComponent } from '@vue/composition-api'
import colorScheme from '../../colorScheme'

export default defineComponent({
  name: 'KaiCheckbox',
  props: {
    subtopicId: {
      type: Number
    },
    colorPalette: {
      type: String,
      default: 'red',
      required: true
    },
    isChecked: {
      type: Boolean,
      default: false,
      required: true
    },
    hasLabelColor: {
      type: Boolean,
      default: false,
      required: false
    },
    xLabel: {
      type: String,
      default: null,
      required: false
    }
  },
  setup() {
    return { colorScheme }
  }
})
